import {
  EMAIL_INPUT_ERROR_TYPE,
  type EmailInputErrorType,
} from '../../core/entities/register/constants';

export const emailRegex =
  /^([\w+-]+)(\.[\w+-]+)*@([a-z\d][a-z\d-]*\.)+[a-z]{2,}$/i;

// Microsoft 系メールドメイン（msn / hotmail / outlook / live）を除外する
// キーワード直後にドット(サブドメイン境界)を要求し、livecareer.com など前方一致するだけの
// 正当なドメインを誤って弾かないようにする
// メールのドメイン部は大文字小文字を区別しないため i フラグで大文字入力もマッチさせる
export const nonMicrosoftMailRegex = /@(?!(msn|hotmail|outlook|live)\.)/i;

/**
 * 会員登録に使うメールアドレスの入力エラー種別を返す。問題なければ NONE
 */
export const validateRegisterEmail = (email: string): EmailInputErrorType => {
  if (email.length > 100) {
    return EMAIL_INPUT_ERROR_TYPE.LENGTH_ERROR;
  }
  if (!emailRegex.test(email)) {
    return EMAIL_INPUT_ERROR_TYPE.FORMAT_ERROR;
  }
  if (!nonMicrosoftMailRegex.test(email)) {
    return EMAIL_INPUT_ERROR_TYPE.MICROSOFT_ERROR;
  }
  return EMAIL_INPUT_ERROR_TYPE.NONE;
};
